var map = {
	"./adidas_logo.jpg": "./src/assets/img/brands/adidas_logo.jpg",
	"./aeromexico_logo.jpg": "./src/assets/img/brands/aeromexico_logo.jpg",
	"./aliexpress_logo.jpg": "./src/assets/img/brands/aliexpress_logo.jpg",
	"./americaneagle_logo.jpg": "./src/assets/img/brands/americaneagle_logo.jpg",
	"./andrea_logo.jpg": "./src/assets/img/brands/andrea_logo.jpg",
	"./avera_logo.jpg": "./src/assets/img/brands/avera_logo.jpg",
	"./babbel_logo.jpg": "./src/assets/img/brands/babbel_logo.jpg",
	"./barcelo_logo.jpg": "./src/assets/img/brands/barcelo_logo.jpg",
	"./bathandbodyworks_logo.jpg": "./src/assets/img/brands/bathandbodyworks_logo.jpg",
	"./bodegaaurrera_logo.jpg": "./src/assets/img/brands/bodegaaurrera_logo.jpg",
	"./bodegadespensa_logo.jpg": "./src/assets/img/brands/bodegadespensa_logo.jpg",
	"./booking_logo.jpg": "./src/assets/img/brands/booking_logo.jpg",
	"./brooksbrothers_logo.jpg": "./src/assets/img/brands/brooksbrothers_logo.jpg",
	"./calvinklein_logo.jpg": "./src/assets/img/brands/calvinklein_logo.jpg",
	"./clickbus_logo.jpg": "./src/assets/img/brands/clickbus_logo.jpg",
	"./columbia_logo.jpg": "./src/assets/img/brands/columbia_logo.jpg",
	"./coppel_logo.jpg": "./src/assets/img/brands/coppel_logo.jpg",
	"./desigual_logo.jpg": "./src/assets/img/brands/desigual_logo.jpg",
	"./dpstreet_logo.jpg": "./src/assets/img/brands/dpstreet_logo.jpg",
	"./dyson_logo.jpg": "./src/assets/img/brands/dyson_logo.jpg",
	"./edx_logo.jpg": "./src/assets/img/brands/edx_logo.jpg",
	"./elektra_logo.jpg": "./src/assets/img/brands/elektra_logo.jpg",
	"./elpalaciodehierro_logo.jpg": "./src/assets/img/brands/elpalaciodehierro_logo.jpg",
	"./emma_logo.jpg": "./src/assets/img/brands/emma_logo.jpg",
	"./enviaflores_logo.jpg": "./src/assets/img/brands/enviaflores_logo.jpg",
	"./etam_logo.jpg": "./src/assets/img/brands/etam_logo.jpg",
	"./expedia_logo.jpg": "./src/assets/img/brands/expedia_logo.jpg",
	"./fever_logo.jpg": "./src/assets/img/brands/fever_logo.jpg",
	"./guess_logo.jpg": "./src/assets/img/brands/guess_logo.jpg",
	"./heb_logo.jpg": "./src/assets/img/brands/heb_logo.jpg",
	"./hertz_logo.jpg": "./src/assets/img/brands/hertz_logo.jpg",
	"./homedepot_logo.jpg": "./src/assets/img/brands/homedepot_logo.jpg",
	"./honor_logo.jpg": "./src/assets/img/brands/honor_logo.jpg",
	"./hp_logo.jpg": "./src/assets/img/brands/hp_logo.jpg",
	"./huawei_logo.jpg": "./src/assets/img/brands/huawei_logo.jpg",
	"./innovasport_logo.jpg": "./src/assets/img/brands/innovasport_logo.jpg",
	"./innvictus_logo.jpg": "./src/assets/img/brands/innvictus_logo.jpg",
	"./jdsports_logo.jpg": "./src/assets/img/brands/jdsports_logo.jpg",
	"./kinguin_logo.jpg": "./src/assets/img/brands/kinguin_logo.jpg",
	"./kiwi_logo.jpg": "./src/assets/img/brands/kiwi_logo.jpg",
	"./labl_logo.jpg": "./src/assets/img/brands/labl_logo.jpg",
	"./lacoste_logo.jpg": "./src/assets/img/brands/lacoste_logo.jpg",
	"./latam_logo.jpg": "./src/assets/img/brands/latam_logo.jpg",
	"./lego_logo.jpg": "./src/assets/img/brands/lego_logo.jpg",
	"./lenovo_logo.jpg": "./src/assets/img/brands/lenovo_logo.jpg",
	"./lulus_logo.jpg": "./src/assets/img/brands/lulus_logo.jpg",
	"./luuna_logo.jpg": "./src/assets/img/brands/luuna_logo.jpg",
	"./mascaradelatex_logo.jpg": "./src/assets/img/brands/mascaradelatex_logo.jpg",
	"./miniso_logo.jpg": "./src/assets/img/brands/miniso_logo.jpg",
	"./motorola_logo.jpg": "./src/assets/img/brands/motorola_logo.jpg",
	"./nike_logo.jpg": "./src/assets/img/brands/nike_logo.jpg",
	"./oldnavy_logo.jpg": "./src/assets/img/brands/oldnavy_logo.jpg",
	"./omio_logo.jpg": "./src/assets/img/brands/omio_logo.jpg",
	"./onboard_logo.jpg": "./src/assets/img/brands/onboard_logo.jpg",
	"./ourbus_logo.jpg": "./src/assets/img/brands/ourbus_logo.jpg",
	"./pandora_logo.jpg": "./src/assets/img/brands/pandora_logo.jpg",
	"./pullandbear_logo.jpg": "./src/assets/img/brands/pullandbear_logo.jpg",
	"./puma_logo.jpg": "./src/assets/img/brands/puma_logo.jpg",
	"./saily_logo.jpg": "./src/assets/img/brands/saily_logo.jpg",
	"./sams_logo.jpg": "./src/assets/img/brands/sams_logo.jpg",
	"./samsonite_logo.jpg": "./src/assets/img/brands/samsonite_logo.jpg",
	"./samsung_logo.jpg": "./src/assets/img/brands/samsung_logo.jpg",
	"./sephora_logo.jpg": "./src/assets/img/brands/sephora_logo.jpg",
	"./sepiia_logo.jpg": "./src/assets/img/brands/sepiia_logo.jpg",
	"./sisley_logo.jpg": "./src/assets/img/brands/sisley_logo.jpg",
	"./skillshare_logo.jpg": "./src/assets/img/brands/skillshare_logo.jpg",
	"./somosreyes_logo.jpg": "./src/assets/img/brands/somosreyes_logo.jpg",
	"./speedo_logo.jpg": "./src/assets/img/brands/speedo_logo.jpg",
	"./stockx_logo.jpg": "./src/assets/img/brands/stockx_logo.jpg",
	"./temu_logo.jpg": "./src/assets/img/brands/temu_logo.jpg",
	"./thrifty_logo.jpg": "./src/assets/img/brands/thrifty_logo.jpg",
	"./ticketmaster_logo.jpg": "./src/assets/img/brands/ticketmaster_logo.jpg",
	"./tommyhilfiger_logo.jpg": "./src/assets/img/brands/tommyhilfiger_logo.jpg",
	"./tous_logo.jpg": "./src/assets/img/brands/tous_logo.jpg",
	"./underarmour_logo.jpg": "./src/assets/img/brands/underarmour_logo.jpg",
	"./virginmobile_logo.jpg": "./src/assets/img/brands/virginmobile_logo.jpg",
	"./volaris_logo.jpg": "./src/assets/img/brands/volaris_logo.jpg",
	"./vrbo_logo.jpg": "./src/assets/img/brands/vrbo_logo.jpg",
	"./walmart_logo.jpg": "./src/assets/img/brands/walmart_logo.jpg",
	"./walmartsuper_logo.jpg": "./src/assets/img/brands/walmartsuper_logo.jpg",
	"./wildfork_logo.jpg": "./src/assets/img/brands/wildfork_logo.jpg",
	"./xiaomi_logo.jpg": "./src/assets/img/brands/xiaomi_logo.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/brands sync recursive ^\\.\\/.*_logo\\.jpg$";